import { Grid, Paper, TableFooter, TablePagination, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { generateGenomicsResearchUrl } from "../../../helpers/generateUrl";
import {
    getClient, getDealer, getFailedSample, getInstitute, getProjects
} from "../../actions/GenomicsResearchAction";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    text: { color: "black" },
  })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#12145e",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  getProjects: any;
  projects: any;
  getDealer: any;
  dealer: any;
  getClient: any;
  client: any;
  getInstitute: any;
  institute: any;
  getFailedSamples: any;
  getFailedSample: any;

}
const StopsPlace: React.FC<Props> = ({
  getProjects,
  projects,
  getDealer,
  dealer,
  getClient,
  client,
  getInstitute,
  institute,
  getFailedSamples,
  getFailedSample,

}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const [page, setPage] = useState(0);
  const [project, setProject] = useState<any>("");
  const [dealers, setDealers] = useState<any>();
  const [dealersName, setDealersName] = useState<any>("");
  const [clientName, setClientgName] = useState<any>("");
  const [clients, setClients] = React.useState<any>();
  const [insName, setInsName] = useState<any>("");
  const [instituteName, setInstituteName] = useState<any>();

  const filterProjectData = (e: any) => {
    const body: any = {
      projectId: project,
      scientist: clients,
      institute: instituteName,
      dealer: dealers,
    };
    const url = generateGenomicsResearchUrl(body).substring(2);
    getProjects(url);
    setPage(0);
  };
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = projects.links && projects.links.next.split("?")[1];
      getProjects(`?${url}`);
    } else if (newPage < page) {
      let url = projects.links && projects.links.previous.split("?")[1];
      getProjects(`${url === undefined ? "" : "?" + url}`);
    }
    setPage(newPage);
  };
  return (
    <form style={{ width: "100%", marginLeft: 14 }} onSubmit={filterProjectData}>
      <Grid container spacing={2} style={{ marginTop: 50 }}>
        <Grid container spacing={3}>
          <Grid item xs={10}>
            <h3>Failed Samples Dashboard</h3>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginTop: 10 }}
        >
          <Grid item xs={12} sm={4} md={3}>
            <Autocomplete
              id="client_name"
              disablePortal
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                  setClients(obj._id);
                }
              }}

              defaultValue={
                { _id: "", name: clientName }
              }
              options={client?.results || []}
              getOptionLabel={(option: any) => `${option?.name}`}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getClient(newInputValue);
                }, 1000);
                setClientgName(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="input"
                  label="Client"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Autocomplete
              id="Institute"
              disablePortal
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                  setInstituteName(obj._id);
                }
              }}
              defaultValue={
                { id: "", name: insName }
              }
              options={institute.results || []}
              getOptionLabel={(option: any) => `${option?.name}`}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getInstitute(newInputValue);
                }, 1000);
                setInsName(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="input"
                  label="Institute Name"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              id="Dealer"
              disablePortal
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                  setDealers(obj._id);
                }
              }}
              defaultValue={
                { id: "", name: dealersName }
              }
              options={dealer.results || []}
              getOptionLabel={(option: any) => `${option?.name}`}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getDealer(newInputValue);
                }, 1000);
                setDealersName(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="input"
                  label="Dealer Name"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              style={{ background: "#9c037d" }}
              fullWidth
              onClick={filterProjectData}
            >
              Filter
            </Button>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => history.push("/dashboard/gnre/failedSamples/")}
            >
              Reset
            </Button>
          </Grid>
        </Grid>

        <Grid container style={{ marginTop: 10 }}>
          <div style={{ width: "100%" }} className="data-table">
            <TableContainer className={classes.tableContainer}
              component={Paper}
              style={{ maxHeight: "550px" }}
            >
             <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">Client Name</StyledTableCell>
                    <StyledTableCell align="center">Institute Name</StyledTableCell>
                    <StyledTableCell align="center">Dealer Name</StyledTableCell>
                    <StyledTableCell align="center">No Of Failed Samples</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {getFailedSamples && getFailedSamples?.results && getFailedSamples?.results?.length > 0 && getFailedSamples?.results?.map((data: any, index: any) => {
                    return (
                      <StyledTableRow >
                        <StyledTableCell align="center">
                          {data?.scientist?.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.institute?.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.dealer?.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {data?.sample?.failedCount}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {/* <Button
                            color="primary"
                            variant="contained"
                            onClick={() =>
                              history.push(
                                `/dashboard/gnre/project-edit/${data._id}/edit`
                              )
                            }
                          >
                            edit
                          </Button> */}
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  })}
                </TableBody>
                <TableFooter>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    colSpan={3}
                    count={projects?.count || 0}
                    rowsPerPage={projects?.page_size}
                    page={page}
                    onPageChange={handleChangePage}
                  />
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        </Grid>
      </Grid>
    </form>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsCAReducer.projects,
  dealer: state.GenomicsCAReducer.dealer,
  client: state.GenomicsCAReducer.client,
  institute: state.GenomicsCAReducer.institute,
  getFailedSamples: state.GenomicsCAReducer.getFailedSamples
});
export default connect(mapStateToProps, {
  getProjects,
  getDealer,
  getClient,
  getInstitute,
  getFailedSample,
})(StopsPlace);
